import { Directive, HostListener, ElementRef, HostBinding, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[appImgDroppable]'
})
export class ImgDroppableDirective {
  @Output('imgUrl') imgUrl = new EventEmitter();
  @HostBinding('style.border') border;
  @HostBinding('style.backgroundImage') backgroundImage;
  @HostBinding('style.backgroundSize') backgroundSize;

  private borderStyle = '2px dashed ';
  private borderMap = {
    allow: this.borderStyle + '#007bff',
    error: this.borderStyle + '#dc3545'
  };

  constructor() {
    this.backgroundSize = 'cover';
  }

  private loadFile(file): void {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = e => {
      if (this.validateTypeImage(file.type)) {
        this.imgUrl.emit({file: file, url: reader.result});
      }
    };
}

  @HostListener('drop', ['$event'])
  public onDrop(ev: any): void {
    this._preventAndStop(ev);
    const dt = ev.dataTransfer;

    if (dt.items.length > 1) {
      return;
    }else  if (dt.items) {
      this.loadFile(dt.items[0].getAsFile());
    }

    this.border = '';
    this._preventAndStop(ev);
  }

  @HostListener('dragleave', ['$event'])
    public onDragLeave(ev: any): any {
        this.border = '';

        this._preventAndStop(ev);
    }

  @HostListener('dragover', ['$event'])
    public onDragOver(ev: any): void {
        const dt = ev.dataTransfer;
        this.border = '';

        if (dt.items.length > 1) {
          this.border = this.borderMap.error;
          this._preventAndStop(ev);
          return;
        }

        this.validateTypeImage(dt.items[0].type);

        this._preventAndStop(ev);

    }


  private validateTypeImage(type: string): boolean {
    switch (type) {
      case 'image/gif':
      case 'image/jpg':
      case 'image/jpeg':
      case 'image/png':
        this.border = this.borderMap.allow;
        return true;
      default:
        this.border = this.borderMap.error;
        return false;
    }
  }

  protected _preventAndStop(event: any): any {
    event.preventDefault();
    event.stopPropagation();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/directives/img-droppable.directive.ts